import { useState } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../auth/AuthProvider';

export function NoAccessPage() {
  const { state, refreshRole, signOutUser } = useAuth();
  const [checking, setChecking] = useState(false);

  if (state.status === 'signedIn' && state.role) return <Navigate to="/clients" replace />;

  return (
    <div className="auth-card">
      <h1>Access not granted</h1>
      <p>
        You are signed in as <strong>{state.status === 'signedIn' ? state.user.email : ''}</strong>, but this
        account has no staff role yet. Ask an admin to grant one.
      </p>
      <div className="actions">
        <button
          type="button"
          className="btn"
          disabled={checking}
          onClick={async () => {
            setChecking(true);
            await refreshRole();
            setChecking(false);
          }}
        >
          {checking ? 'Checking…' : 'Check again'}
        </button>
        <button type="button" className="btn btn--ghost" onClick={() => void signOutUser()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
